import { render, staticRenderFns } from "./fields-button.vue?vue&type=template&id=13615cb2&scoped=true&"
import script from "./fields-button.vue?vue&type=script&lang=js&"
export * from "./fields-button.vue?vue&type=script&lang=js&"
import style0 from "./fields-button.vue?vue&type=style&index=0&id=13615cb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13615cb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13615cb2')) {
      api.createRecord('13615cb2', component.options)
    } else {
      api.reload('13615cb2', component.options)
    }
    module.hot.accept("./fields-button.vue?vue&type=template&id=13615cb2&scoped=true&", function () {
      api.rerender('13615cb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/common/fields-button.vue"
export default component.exports